module.exports = __webpack_public_path__ + "img/Dots.0cff1065.svg";